'use client';
import { ThemeProvider } from '@mui/material/styles';
import * as React from 'react';
import { PropsWithChildren, useMemo } from 'react';
import getDarkTheme from './mui/darkTheme';
import { useTenant } from './tenant/TenantProvider';

type Props = {};

const DarkThemeProvider = ({ children }: PropsWithChildren<Props>) => {
  const { theme, tenantConfig } = useTenant();
  const darkTheme = useMemo(
    () => getDarkTheme(theme, tenantConfig.theme?.palette.darkMode),
    [theme, tenantConfig],
  );

  return (
    <ThemeProvider theme={darkTheme} defaultMode={'dark'}>
      {children}
    </ThemeProvider>
  );
};

export default DarkThemeProvider;
